angular.module("vgresiduos").controller("apiRequestEventCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `api-request-event`);
		};
	}
]);
